import React from "react";
import { SafetyCertificateOutlined } from "@ant-design/icons";
import "./authLayout.css";

const AuthLayout = ({ children, title, subtitle }) => {
  return (
    <div className="auth-page">

      {/* HEADER */}
      <header className="auth-header">
        <SafetyCertificateOutlined className="logo-icon" />
        <span>Steel City Press CMS</span>
      </header>

      {/* BODY */}
      <div className="auth-body">

        {/* LEFT BRAND SIDE */}
        <div className="auth-left">
          <h1>{title || "Welcome Back 👋"}</h1>
          <p>
            Manage Recent Works, Teams, Machineries & Customer Feedbacks
            from one powerful admin dashboard.
          </p>
        </div>

        {/* RIGHT CONTENT */}
        <div className="auth-right">
          {children}
        </div>
      </div>
    </div>
  );
};

export default AuthLayout;
